<script lang="ts">
	import type { HTMLButtonAttributes } from "svelte/elements";
	import ButtonContent from "./ButtonContent.svelte";
	import { ButtonVariant, type ButtonVariant as ButtonVariantType, getButtonClass } from "./getButtonClass.js";

	const {
		variant,
		iconStart,
		iconEnd,
		...rest
	}: { variant: ButtonVariantType; iconStart?: string; iconEnd?: string } & HTMLButtonAttributes = $props();

	const iconSize =
		variant === ButtonVariant.PrimarySmall || variant === ButtonVariant.SecondarySmall ? "small" : "medium";
</script>

<button
	{...rest}
	type={rest.type ?? (rest.onclick ? "button" : undefined)}
	class="{getButtonClass(variant)} {rest.class}"
>
	<ButtonContent {iconStart} {iconEnd} {iconSize}>
		{@render rest.children?.()}
	</ButtonContent>
</button>
